export default "__VITE_ASSET__BWupqdsH__"